import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { emailAuditCopy } from '@/lib/site/email-audit-content'

/** The free audit's copy in the reader's language, for the client island. */
export function useEmailAuditCopy() {
  const t = useTranslations('freeEmailAudit')
  return useMemo(() => emailAuditCopy(t), [t])
}
